import React, { useMemo, useState } from 'react';
import classnames from 'classnames';
import Layout from 'sections/Layout';
import parse, { domToReact } from 'html-react-parser';

import Hero from 'sections/ResourceCenterPost/Hero';
import Content from 'sections/ResourceCenterPost/Content';
import AsideNav from 'sections/ResourceCenterPost/AsideNav';
// import Rating from 'sections/common/Rating';
import Rating from 'sections/common/Rating/RatingFromServey';
import Share from 'sections/ResourceCenterPost/Share';
import Builder from 'sections/ResourceCenterPost/Builder';
import MoreStoriesSec from 'sections/common/MoreStoriesSec';

import stringToSlug from 'helpers/stringToSlug';
import { DESKTOP_KEY } from 'constants/devices.js';
import useDeviceState from 'hooks/useDeviceState';
import useAllResourceCenterPosts from 'hooks/graphql/useAllResourceCenterPosts';
import { RESOURCE_CENTER } from 'constants/urls';

import * as styles from 'styles/pages/resource-center-post.module.scss';

const ResourceCenterPost = ({ resourceCenterPost, ...props }) => {
  const [anchors, setAnchors] = useState([]);
  const deviceState = useDeviceState();
  const allResourceCenterPosts = useAllResourceCenterPosts();

  const {
    content,
    // databaseId,
    slug,
    title,
    tags,
    id,
    seo,
    template: {
      resourceCenterPost: articleCustomFields,
      resourceCenterPost: sectionBuilder,
    },
    template: {
      resourceCenterPost: { resourceCenterPostRatingSource },
    },
  } = resourceCenterPost;

  const currentPostCategory = resourceCenterPost.categories.nodes[0].name;
  const currentPostId = id;

  const additionalLink = {
    text: 'More Content',
    url: RESOURCE_CENTER,
  };

  const builder = sectionBuilder.resourceCenterPostSectionsBuilder;

  const options = useMemo(
    () => ({
      replace: (node) => {
        if (['h3'].includes(node.name)) {
          const lable = domToReact(node.children, options);
          const slug = stringToSlug(lable);

          setAnchors((store) => [...store, { link: slug, lable: lable }]);

          return (
            <>
              <h3 className={classnames('scr-h3')} id={slug}>
                {lable}
              </h3>
            </>
          );
        }

        return node;
      },
    }),
    [setAnchors]
  );

  const currentContent = useMemo(() => parse(content || '', options), [
    content,
    options,
  ]);

  return (
    <Layout
      seo={seo}
      headerDarkColor={true}
      headerWhiteBg={true}
      requestButtonBlue={true}
      // ogImage={sourceUrl}
    >
      {(commonData) => (
        <>
          <div className={classnames(styles.wrap, 'scr-wrap')}>
            {deviceState === DESKTOP_KEY && (
              <div className={classnames(styles.wrap_aside)}>
                <AsideNav data={anchors} postSlug={slug} />
              </div>
            )}

            <div className={classnames(styles.wrap_content)}>
              <Hero
                data={resourceCenterPost}
                customFields={articleCustomFields}
              />
              <Content data={currentContent} />
            </div>
          </div>

          <div className="scr-wrap">
            <div className={classnames(styles.postInfo)}>
              {/* TODO: OLD RATING */}
              {/* <Rating databaseId={databaseId} /> */}
              {resourceCenterPostRatingSource ? (
                <Rating src={resourceCenterPostRatingSource} title={title} />
              ) : null}

              <Share url={slug} title={title} tags={tags} uri={props.uri} />
            </div>

            <Builder data={builder} />

            <MoreStoriesSec
              tag={currentPostCategory}
              id={currentPostId}
              title={'You May Be Interested'}
              allPosts={allResourceCenterPosts}
              reading={true}
              additionalLink={additionalLink}
            />
          </div>
        </>
      )}
    </Layout>
  );
};

export default ResourceCenterPost;
